<template>
  <div class="visually-hidden">
    <!-- @slot hides anything present in the slot from regular devices, and shows it to assistive technologies -->
    <slot></slot>
  </div>
</template>

<script>
/** Visually Hidden is used when an element needs to be available to assistive technology, but otherwise hidden.
The visually hidden component hides text visually from screen, but keeps it available to assistive technologies, such as screen readers. The component shouldn’t be used to hide interactive content. */
export default {
  name: "MksVisuallyHidden",
  release: "1.1.3"
};
</script>

<style lang="scss">
.visually-hidden {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
</style>


